export default __webpack_public_path__ + "static/media/database-plain.2fa94ce1.svg";